export class ConsumerPropertyListing {
    public ListingId: string = "";
    public MlsId: string = "";
    public MlsNumber: string = "";
    public Status: string = "";
    public StreetAddress: string = "";
    public UnitNumber: string = "";
    public City: string = "";
    public State: string = "";
    public PostalCode: string = "";
    public Latitude: number | null = null;
    public Longitude: number | null = null;
    public Price: number | null = null;
    public SquareFeet: number | null = null;
    public YearBuilt: number | null = null;
    public Bedrooms: number | null = null;
    public Bathrooms: number | null = null;
    public Notes: string = "";
    public ProvidedBy: string = "";
    public PropertyImageLinks: string[] = [];
    public DetailsUrl: string = "";
}
